import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

//styles
import "./assets/css/styles.css";
import "./assets/css/custom.css";
import "./assets/css/modal.css";

//Components
import App from "./App";
import SelectionUserType from "./components/SelectionUser/SelectionUserType";

//module sponsor
import IndexSponsor from "./components/Sponsor/Sponsor/Index";
import IndexCampaign from "./components/Sponsor/Campaign/Index";
import IndexBackgroundPrice from "./components/Sponsor/BackgroundPrice/Index";
import IndexDistroPreset from "./components/Sponsor/DistroPreset/Index";
import IndexRarity from "./components/Sponsor/Rarity/Index";
import UpdateDistroColors from "./components/Sponsor/DistroColors/Index";
import IndexWebsite from "./components/Sponsor/WebSite/IndexWebsite";
import UpdateMainPage from "./components/Sponsor/MainPage/Index";
import UpdateAbout from "./components/Sponsor/About/Index";

//Global Error Popup
import GlobalErrorPopup from "./components/Common/GlobalErrorPopup";

//module art
import IndexArt from "./components/Artist/Artist/Index";
import IndexArtPack from "./components/Artist/ArtPack/Index";
import Index from "./components/Artist/Background/Index";
import IndexApprovedName from "./components/Artist/ApprovedName/Index";
import IndexApprovedCampaign from "./components/Artist/ApprovedCampaign/Index";
import IndexPattern from "./components/Artist/Pattern/Index";
import IndexLayer from "./components/Artist/Layer/Index";
import IndexLayerChoice from "./components/Artist/LayerChoice/Index";
import IndexLayerChoiceClass from "./components/Artist/LayerChoiceClass/Index";
import IndexLayerChoiceStyleColor from "./components/Artist/LayerChoiceStyleColor/Index";

import constants from "./utils/constants";
import CustomOutlet from "./components/Common/CustomOutlet";
import Home from "./components/Template/Components/HomePage/Home";
import MyPage from "./components/Template/Components/MyPage";
import Mint from "./components/Template/Components/Mint/Mint";
import Buy from "./components/Template/Components/Buy";
import Faqs from "./components/Template/Components/Faqs";
import { GlobalProvider } from "./context/GlobalContextProvider";
import PreviewLayout from "./components/Template/Components/PreviewLayout";
import { PreviewProvider } from "./context/PreviewContextProvider";

function Main() {
  return (
    <Router>
      <GlobalProvider>
        <PreviewProvider>
          <GlobalErrorPopup />
          <Routes>
            <Route exact path="/" element={<App />}>
              <Route path="" element={<SelectionUserType />} />

              {/* Sponsor Routes */}
              <Route path={constants.SPONSOR_BASE_PATH} element={<CustomOutlet />}>
                <Route path="" element={<IndexSponsor />} />
                <Route path="campaign" element={<IndexCampaign />} />
                <Route path="background-price" element={<IndexBackgroundPrice />} />
                <Route path="distro-preset" element={<IndexDistroPreset />} />
                <Route path="rarity-background" element={<IndexRarity />} />
                <Route path="website" element={<IndexWebsite />} />
                <Route path="distro-colors" element={<UpdateDistroColors />} />
                <Route path="mainpage" element={<UpdateMainPage />} />
                <Route path="about" element={<UpdateAbout />} />
              </Route>

              {/* Artist Routes */}
              <Route path={constants.ARTIST_BASE_PATH} element={<CustomOutlet />}>
                <Route path="" element={<IndexArt />} />
                <Route path="art-pack" element={<IndexArtPack />} />
                <Route path="background" element={<Index />} />
                <Route path="approved-name" element={<IndexApprovedName />} />
                <Route path="pattern" element={<IndexPattern />} />
                <Route path="approved-campaign" element={<IndexApprovedCampaign />} />
                <Route path="layer" element={<IndexLayer />} />
                <Route path="layerchoice" element={<IndexLayerChoice />} />
                <Route path="layer-choice-class" element={<IndexLayerChoiceClass />} />
                <Route path="layer-choice-style-color" element={<IndexLayerChoiceStyleColor />} />
              </Route>
            </Route>

            {/* Preview Routes*/}
            <Route path="/preview-home" element={<PreviewLayout />} >
              <Route path="" element={<Home />} />
              <Route path="/preview-home/my" element={<MyPage />} />
              <Route path="/preview-home/buy" element={<Buy />} />
              <Route path="/preview-home/mint" element={<Mint />} />
              <Route path="/preview-home/faqs" element={<Faqs />} />
            </Route>
          </Routes>
        </PreviewProvider>
      </GlobalProvider>
    </Router >

  );
}

export default Main;
